import { render } from "./ObjectConfigComponent.vue?vue&type=template&id=dc5b342a&scoped=true&ts=true"
import script from "./ObjectConfigComponent.vue?vue&type=script&lang=ts"
export * from "./ObjectConfigComponent.vue?vue&type=script&lang=ts"

import "./ObjectConfigComponent.vue?vue&type=style&index=0&id=dc5b342a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc5b342a"]])

export default __exports__